import { ConsignmentCurationUpdatePage } from "@/features/consignment-curation/pages/ConsignmentCurationUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-curation/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: {
					operator: "OR",
					permissions: ["consignment_setup.view", "consignment_setup.update"],
				},
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentCurationUpdatePage,
});
